import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:lang?',
    name: 'home',
    component: Home
  },
  {
    path: '/:lang?/site/',
    name: 'home-money',
    component: Home
  },
  {
    path: '/:lang?/article/:article',
    name: 'article',
    component: Home
  },
  {
    path: '/:lang?/:category/:name/',
    name: 'game',
    component: Home
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
